import React, { useState } from 'react';
import EditCase from 'components/Cases/EditCase';
import { CustomerType } from 'store/modules/Customers/types';
import api from 'api';
import { Notify } from 'utils';
interface CaseProps {
  caseInfo: {
    name: string;
    id: number;
    customers: Array<CustomerType>;
  };
  setEditCaseInfo: Function;
  editCaseInfo: boolean;
  refreshCaseList: Function;
}

const EditCasePage = ({
  caseInfo,
  setEditCaseInfo,
  refreshCaseList
}: CaseProps) => {
  const [newCustomer, setNewCustomer] = useState(false);

  const createNewCustomer = (
    firstName: string,
    lastName: string,
    intelligentOfficeId = null
  ) => {
    return api
      .createCustomer({ firstName, lastName, intelligentOfficeId })
      .then((customer: any) => {
        return api
          .linkCustomerToCase({
            portfolio: caseInfo.id,
            customerId: customer.data.id
          })
          .then(result => {
            caseInfo.customers = result.data.results.slice(0, 2);
          });
      });
  };

  const saveCustomer = (first_name: string, last_name: string, id: number) => {
    const dataToSend = {
      id,
      first_name,
      last_name
    };

    return api.editCustomer(dataToSend).catch(err => {
      Notify.error(err.response.data.message);
    });
  };

  const saveCaseData = async (val: any) => {
    await saveCustomer(
      val.customers[0].first_name,
      val.customers[0].last_name,
      val.customers[0].id
    );
    if (newCustomer) {
      await createNewCustomer(
        val.customers[1].first_name,
        val.customers[1].last_name
      );
    } else if (val.customers[1]) {
      await saveCustomer(
        val.customers[1].first_name,
        val.customers[1].last_name,
        val.customers[1].id
      );
    }
    const { customers, ...data } = val;
    return api
      .editCase({ caseInfo: data })
      .then(() => {
        if (customers.length > 1)
          caseInfo.customers = caseInfo.customers.slice(0, 2);
        refreshCaseList();
        setEditCaseInfo(false);
      })
      .catch(err => Notify.error(err.response.data.message));
  };

  const props = {
    setEditCaseInfo,
    setNewCustomer,
    newCustomer
  };
  caseInfo.customers =
    caseInfo.customers.length === 1
      ? caseInfo.customers
      : caseInfo.customers.slice(0, 2);
  return (
    <EditCase initialValues={caseInfo} onSubmit={saveCaseData} {...props} />
  );
};

export default EditCasePage;
